import React from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from '../input.component.module.styl';

import type {ComponentProps} from 'react';


const classNames = withCssModule(styles);

type NativeProps = ComponentProps<'div'>;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface Props extends NativeProps {}

export const InputGroup = (props: Props) => {
    return (
        <div {...props} className={classNames('input-group', props.className)}/>
    );
};

InputGroup.displayName = 'InputGroup';
